import { Tag as TagEleProp } from '@varo/graphql-schema-types';
import React from 'react';
import { Pressable, StyleSheet, View } from 'react-native';
import RadioIcon from 'shared/components/RadioIcon/RadioIcon';
import Icon, { IconKeyType } from 'shared/components/vxl/icon/Icon/Icon';
import Illustration, {
  IllustrationKeyType,
} from 'shared/components/vxl/Illustration/Illustration';
import { Tag } from 'shared/components/vxl/Tag/Tag';
import { toTagType } from 'shared/components/vxl/Tag/Tag.helpers';
import BodySmBoldText from 'shared/components/vxl/typography/primary/body/BodySmBoldText';
import theme from 'shared/styles/theme';

export interface FundingRadioBtnSelectionProps {
  id: string;
  title: string;
  tags?: TagEleProp[];
  isSelected?: boolean;
  illustration: IllustrationKeyType | IconKeyType;
  onPress?: () => void;
}

const FundingRadioBtnSelection = ({
  title,
  illustration,
  tags,
  id,
  onPress,
  isSelected = false,
}: FundingRadioBtnSelectionProps) => {
  return (
    <Pressable
      style={[styles.container, isSelected && styles.selected]}
      id={id}
      onPress={onPress}
      accessible
      accessibilityLabel={title}
      accessibilityRole="radio"
    >
      <View style={styles.contentContainer}>
        <RadioIcon selected={isSelected} />
        <View style={styles.contentInner}>
          <BodySmBoldText style={styles.labelText}>{title}</BodySmBoldText>
          {tags && tags.length > 0 && (
            <View style={styles.tagsContainer}>
              {tags.map((tag: TagEleProp) => (
                <Tag
                  key={`tag-${tag.text}`}
                  text={tag.text}
                  type={toTagType(tag.tagColor)}
                  iconKey={tag.icon}
                />
              ))}
            </View>
          )}
        </View>
      </View>
      <View style={styles.illustrationContainer}>
        {illustration === 'APPLE_PAY' || illustration === 'GOOGLE_PAY' ? (
          <Icon iconKey={illustration as IconKeyType} iconSize={48} />
        ) : (
          <Illustration illustration={illustration as IllustrationKeyType} />
        )}
      </View>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    backgroundColor: theme.color.background.primary,
    borderColor: theme.color.border.primary,
    borderRadius: 4,
    borderWidth: 1,
    flex: 1,
    flexDirection: 'row',
    gap: theme.spacing.m,
    justifyContent: 'space-between',
    padding: theme.spacing.m,
  },
  contentContainer: {
    alignItems: 'center',
    flex: 1,
    flexDirection: 'row',
    gap: theme.spacing.m,
  },
  contentInner: {
    flex: 1,
    gap: theme.spacing.xs,
  },
  illustrationContainer: {
    height: 56,
    width: 56,
  },
  labelText: {
    color: theme.color.interactive.primary,
  },
  selected: {
    borderColor: theme.color.interactive.primary,
  },
  tagsContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing.xs,
  },
});

export default FundingRadioBtnSelection;
